<template src='./formSearch.pug' lang='pug'></template>

<script>
import ButtonSearch from '../../buttons/buttonSearch/ButtonSearch'

export default {
  name: 'FormSearch',

  components: {
    ButtonSearch
  },

  props: {
    fn: {
      type: Function,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: true
    },
    getMessages: {
      type: Function,
      default: () => []
    },
    interval: {
      type: Number,
      default: 2500
    },
    hasExportFile: {
      type: Boolean,
      required: true
    },
    exportFileFlag: {
      type: Boolean
    },
    showLoadingFullPage: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isExporting: this.exportFileFlag,
      color: {checked: '#40b9bb', unchecked: '#E5E5E5'}
    }
  },

  methods: {
    send () {
      if (!this.showLoadingFullPage) {
        this.fn()
        return
      }

      const params = {
        messages: this.getMessages(),
        interval: this.interval
      }
      this.$store.dispatch('loadingFullPage', params)
      this.fn().finally(() => {
        this.$store.dispatch('fullPageLoaded')
      })
    }
  }
}
</script>

<style>
.search-button {
  min-width: 7vw;
}
</style>



// WEBPACK FOOTER //
// FormSearch.vue?43063302